import { FeatureFlagsState } from './state';
import { MutationTree } from 'vuex';

const mutations: MutationTree<FeatureFlagsState> = {
  ENROLLMENTS_UG_ENABLE_COUNTY_FIELD(state, payload: boolean): void {
    state['enrollments-ug-enable-county-field'] = payload;
  },
};

export default mutations;
